<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper">
      <div class="page__header">
        <div class="page__title">
          <Title>{{$t($route.meta.title)}}</Title>
        </div>
      </div>
      <div class="page__body">
        <div class="form">
          <div class="form__wrapper">
            <div class="form__item">
              <label class="form__field" :class="{'is-valid': isValidForm}">
                <span class="form__field-caption">{{ $t('phone.title') }} *</span>
                <input data-paylogic-keyboard="phone" @input="onChange" class="form__field-input" v-model="form.phone" placeholder="" type="tel"/>
                <div class="form__field-error"/>
              </label>
            </div>
            <div class="form__actions">
              <ButtonsSet>
                <template v-slot:side>
                  <Button @click="back" outline icon-arrow-left></Button>
                </template>
                <template v-slot:main>
                  <Button :disabled="!isValidForm" @click="create" full>{{ $t('confirm.next') }}</Button>
                </template>
              </ButtonsSet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneController from './phone-controller'
import Title from '@/components/titles/Title'
import Button from '@/components/buttons/Button'
import ButtonsSet from '@/components/buttons-set/ButtonsSet'

export default {
  name: 'Phone',
  mixins: [PhoneController],
  components: {
    Title,
    Button,
    ButtonsSet
  }
}
</script>
